import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MemberQuery } from '@fgb/core';
import { map } from 'rxjs/operators';

@Component({
  selector: 'fgb-account-details-page',
  templateUrl: './account-details-page.component.html',
  styleUrls: ['./account-details-page.component.scss'],
})
export class AccountDetailsPageComponent implements OnInit {
  name$: string;
  dsnIframeUrl: SafeResourceUrl;

  constructor(private memberQuery: MemberQuery, private sanitizer: DomSanitizer) {
    this.dsnIframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl('https://loyaltyid.suns.com/account/link-dsn');
  }

  ngOnInit() {
    this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
      if (m) {
        return `${m.FirstName} ${m.Surname}`;
      }
      return '';
      })
    ).subscribe((name) => {
      this.name$ = name;
    });
  }
  
}
